import Events from '@/scripts/lib/Events';
import { showModal } from '@/scripts/utils/base';

/** @type {MobileMenu} */
let mobileMenu = null;

export default class MobileMenu {
   events = new Events();
   modalId = 'mobile-menu';

   /** @param {HTMLElement} headerMenu */
   constructor(headerMenu) {
      if (mobileMenu) return mobileMenu;
      this.headerMenu = headerMenu;
      this._init();
   }

   show() {
      this.events.emit('show');
      showModal(this.modalId);
   }

   _init() {
      this._getElements();
      this._initEvents();
   }

   _initEvents() {
      this.events.addListenerOnce('show', () => {
         this._render();
      });
   }

   _render() {
      const list = this.headerMenu.cloneNode(true);
      this._prepareMenuList(list);
      this.$itemsContainer.appendChild(list);
   }

   /** @param {HTMLElement} list */
   _prepareMenuList(list) {
      const items = list.querySelectorAll('.header-menu--link');
      items.forEach(($) => {
         $.removeAttribute('tabindex');
      });
   }

   _getElements() {
      this.$root = document.querySelector(`#${this.modalId}`);
      this.$itemsContainer = this.$root.querySelector('.items-container-js');
   }
}